/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ContentChild, HostBinding, TemplateRef } from '@angular/core';
import { LiftContainer } from './lift-container.service';

@Component({
  selector: 'gh-lift',
  template: `
    <ng-content></ng-content>`,
  styles: [require('./lift.component.scss')],
  exportAs: 'ghLift',
})
export class LiftComponent {
  @HostBinding('class.raised')
  raised: boolean = false;

  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;

  constructor(private container: LiftContainer) {

  }

  up(): void {
    this.raised = true;
    this.container.showOverlay();
  }

  down(): void {
    this.container.hideOverlay();
    this.raised = false;
  }
}
